<template>
  <div
    id="send-mails-generate-pdf"
    tabindex="-1"
    aria-hidden="true"
    class="fixed top-0 left-0 right-0 z-50 hidden w-full px-4 py-12 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-2rem)] md:h-full"
  >
    <div class="relative w-full h-full max-w-xl pt-6 pb-6 bg-transparent">
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow ">
        <button
          type="button"
          class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center  "
          @click="onClose"
        >
          <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
          <span class="sr-only">Close modal</span>
        </button>
        <!-- Modal header -->
        <div class="px-6 py-4 border-b rounded-t ">
          <h3 class="text-base font-semibold text-gray-900 lg:text-xl ">
           ** {{ labels["TITLE_SELECT_PRODUCT_TYPE"][lg] }}
          </h3>
        </div>
        <!-- Modal body -->
        <div class="p-6">
          <div class="h-72 w-full p-4">
            <p class="text-sm font-normal text-gray-500  flex w-full text-left justify-start">
              {{ labels["TITLE_GENERATE_DOCUMENT"][lg] }}
            </p>

            <ul class="my-4 space-y-1 overflow-auto text-gray-800">
              <li class="cursor-pointer py-1 px-3 cursor-pointer" @click="onSelectGeneratePdf()">
                <div class="flex items-start mb-2 px-3 cursor-pointer">
                  <input
                    id="generate-pdf-checkbox"
                    type="checkbox"
                    :checked="generate_pdf"
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
                  />
                  <label for="generate-pdf-checkbox`" class="cursor-pointer ms-2 text-sm font-medium text-gray-900 "> Oui régénérer le fichier </label>
                </div>
              </li>
            </ul>

            <p class="text-sm font-normal text-gray-500  flex w-full text-left justify-start">
              {{ labels["TITLE_SELECT_PRODUCT_TYPE_COMMENT"][lg] }}
            </p>

            <ul class="my-4 space-y-1 overflow-auto text-gray-800 h-30 overflow-y-auto">
              <li v-for="record in checkEmails(input?.emails)" :key="record" class="cursor-pointer py-1 px-3 cursor-pointer" @click="onSelect(record)">
                <div class="flex items-start mb-1 px-3">
                  <input
                    :id="`${record}-checkbox`"
                    type="checkbox"
                    :checked="output[record]"
                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500    "
                  />
                  <label for="`${record.id}-checkbox`" class="cursor-pointer ms-2 text-sm font-medium text-gray-900 "> {{ record }} </label>
                </div>
              </li>
            </ul>

            <div class="my-4 space-x-3 overflow-auto text-gray-800 flex flex-row items-center justify-end w-full">
              <div class="text-blue-700 underline text-xs cursor-pointer hover:text-blue-900" @click="selectAll">tout sélectionnner</div>
              <div class="text-blue-700 underline text-xs cursor-pointer hover:text-blue-900" @click="unselectAll">tout désélectionnner</div>
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end px-6 py-3 bg-gray-200">
          <button
            type="button"
            class="mr-3 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200      "
            @click="onClose"
          >
            Annuler
          </button>
          <button
            type="button"
            class="inline-flex items-center text-white bg-gray-600 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center  "
            @click="onValidate"
          >
            Valider
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import labels from "@/assets/lg/select-mails-modal.json";

export default {
  name: "SelectUsersModal",
  components: {},
  props: {
    input: Object,
  },
  data() {
    return {
      lg: "FR",
      output: {},
      generate_pdf: false,
      labels: labels,
      isLoading: false,
      selected: [],
    };
  },
  watch: {
    input: function () {
      if (this.input?.mode == "send-emails-only") {
        this.generate_pdf = false;
        this.selectAll();
      }

      if (this.input?.mode == "send-generate-pdf-only") {
        this.generate_pdf = true;
        this.unselectAll();
      }
    },
  },
  mounted() {},
  methods: {
    checkEmails(ar) {
      if (typeof ar == "string") {
        return ar.split(";");
      }
      return ar;
    },
    selectAll() {
      for (let i = 0; i < this.input.emails?.length; i++) {
        this.output[this.input.emails[i]] = true;
      }
    },
    unselectAll() {
      for (let i = 0; i < this.input.emails?.length; i++) {
        this.output[this.input.emails[i]] = false;
      }
    },
    onSelect(id) {
      if (this.output[id] == undefined) this.output[id] = false;

      this.output[id] = !this.output[id];
    },

    onSelectGeneratePdf() {
      if (this.generate_pdf == undefined) this.generate_pdf = false;

      this.generate_pdf = !this.generate_pdf;
    },

    onValidate() {
      let emails = [];
      let keys = Object.keys(this.output);
      for (let k = 0; k < keys.length; k++) {
        if (this.output[keys[k]] == true) emails.push(keys[k]);
      }

      this.$emit("confirm", { generate_pdf: this.generate_pdf, emails: emails, document: this.input.document });
      // this.output = []
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>
